var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPositionAero(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 204.63 180.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Laag_2",
    "data-name": "Laag 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.57,
    y: 103.04,
    width: 0.43,
    height: 74.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.57,
    y: 103.04,
    width: 0.43,
    height: 74.4,
    transform: "translate(-87.51 69.21) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.59,
    y: 140.02,
    width: 74.4,
    height: 0.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.59,
    y: 140.02,
    width: 74.4,
    height: 0.43,
    transform: "translate(-87.56 69.29) rotate(-45.04)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.59,
    y: 140.02,
    width: 74.4,
    height: 0.43,
    transform: "translate(-104.94 122.77) rotate(-67.28)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.57,
    y: 103.04,
    width: 0.43,
    height: 74.4,
    transform: "translate(-50.13 25.5) rotate(-22.25)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.57,
    y: 103.04,
    width: 0.43,
    height: 74.4,
    transform: "translate(-104.93 122.7) rotate(-67.25)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.59,
    y: 140.02,
    width: 74.4,
    height: 0.43,
    transform: "translate(-50.17 25.53) rotate(-22.27)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.59,
    y: 140.02,
    width: 74.4,
    height: 0.43,
    transform: "translate(-105.42 153.07) rotate(-79.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.57,
    y: 103.04,
    width: 0.43,
    height: 74.4,
    transform: "translate(-71.87 46.53) rotate(-34.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.57,
    y: 103.04,
    width: 0.43,
    height: 74.4,
    transform: "translate(-105.43 152.93) rotate(-79.15)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.59,
    y: 140.02,
    width: 74.4,
    height: 0.43,
    transform: "translate(-71.83 46.48) rotate(-34.13)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.59,
    y: 140.02,
    width: 74.4,
    height: 0.43,
    transform: "translate(-99.06 95.83) rotate(-56.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.57,
    y: 103.04,
    width: 0.43,
    height: 74.4,
    transform: "translate(-26.94 10.63) rotate(-11.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.57,
    y: 103.04,
    width: 0.43,
    height: 74.4,
    transform: "translate(-99.04 95.78) rotate(-56.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.59,
    y: 140.02,
    width: 74.4,
    height: 0.43,
    transform: "translate(-26.96 10.64) rotate(-11.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39.79,177.73a37.49,37.49,0,1,1,37.49-37.49A37.53,37.53,0,0,1,39.79,177.73Zm0-70.1A32.61,32.61,0,1,0,72.4,140.24,32.65,32.65,0,0,0,39.79,107.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M43.82,140.24a4,4,0,1,1-4-4A4,4,0,0,1,43.82,140.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M39.79,180a39.79,39.79,0,1,1,39.79-39.79A39.84,39.84,0,0,1,39.79,180Zm0-74.4A34.61,34.61,0,1,0,74.4,140.24,34.65,34.65,0,0,0,39.79,105.63Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 57.51,
    y: 90,
    width: 71.64,
    height: 3.81
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "112.66 141.07 54.55 98.96 56.39 95.63 114.5 137.74 112.66 141.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.29,70.87a7.94,7.94,0,1,0,0,15.88,2.14,2.14,0,0,0,0-4.28h0a3.67,3.67,0,0,1,0-7.33H60.64L38.38,140.41l3.47,1.18,23-66.46A3.15,3.15,0,0,0,64,72a4.48,4.48,0,0,0-2.88-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M61.11,70.87H45.29a7.94,7.94,0,1,0,0,15.88,2.14,2.14,0,0,0,0-4.28h0a3.67,3.67,0,0,1,0-7.33H60.64L56.13,88.37h4.14l4.58-13.24A3.15,3.15,0,0,0,64,72,4.48,4.48,0,0,0,61.11,70.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M45.29,86.75a2.14,2.14,0,0,0,0-4.28h0a3.67,3.67,0,0,1,0-7.33h5.87V70.87H45.29a7.94,7.94,0,1,0,0,15.88Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "110.92 141 114.39 142.18 139.15 62.91 134.94 62.91 110.92 141"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M146.94,64.52a1,1,0,0,0,.11-1.29c-.4-.87-1.45-2.61-4.8-2.49s-8.16,1-11.65.66-8.42-.29-10.78.37-3.06,1.89-2,2.32,4.15.54,7.66.62a22.94,22.94,0,0,1,7.4,1.4c1.79.58,2.1,1,3.63.81s3.79-1.65,5.83-2S146.75,64.78,146.94,64.52Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "115.73 150.8 115.62 149.94 164.57 143.41 164.68 144.27 115.73 150.8"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 138.96,
    y: 108.23,
    width: 1.29,
    height: 49.89,
    transform: "translate(-16.16 247.03) rotate(-79.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M122.65,136.41s-3.69,2.1-6.4,1.22a4.07,4.07,0,0,0-1.87-1.84h0c-.9-2.72,1.21-6.42,1.21-6.42l-2.94-.77h0l-3,.77s2.12,3.7,1.21,6.42h0a4,4,0,0,0-1.86,1.84c-2.72.88-6.4-1.22-6.4-1.22l-.77,3h0l.77,2.94s3.63-2.07,6.34-1.23a4,4,0,0,0,1.94,2c.81,2.71-1.24,6.32-1.24,6.32l3,.77h0l2.94-.77s-2-3.61-1.24-6.32a4,4,0,0,0,1.94-2c2.71-.84,6.35,1.23,6.35,1.23l.77-2.94h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M112.66,151.2a11.8,11.8,0,1,1,11.79-11.79A11.81,11.81,0,0,1,112.66,151.2Zm0-21.86a10.07,10.07,0,1,0,10.07,10.07A10.07,10.07,0,0,0,112.66,129.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M110.75,139.24a3.64,3.64,0,0,1-1.66,1,32.75,32.75,0,0,0-6.6,2.41c-2.27,1.21-6.29,3.24-6.29,3.24l-.78,3a40,40,0,0,1,3.9-1.56,59.92,59.92,0,0,0,7.21-2.85c2.1-1.06,3.94-2.25,4.64-2.34a6,6,0,0,0,1.68-.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M97.43,147.45a2,2,0,0,1-2,2H90.35a2,2,0,0,1-2-2h0a2,2,0,0,1,2-2H95.4a2,2,0,0,1,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M94.33,147.45A1.46,1.46,0,1,1,92.87,146,1.46,1.46,0,0,1,94.33,147.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M114.86,139.41a2.21,2.21,0,1,1-2.2-2.21A2.19,2.19,0,0,1,114.86,139.41Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 164.62,
    y: 103.04,
    width: 0.43,
    height: 74.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 164.63,
    y: 103.04,
    width: 0.43,
    height: 74.4,
    transform: "translate(-50.88 157.63) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 127.64,
    y: 140.02,
    width: 74.4,
    height: 0.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 127.64,
    y: 140.02,
    width: 74.4,
    height: 0.43,
    transform: "translate(-50.88 157.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 127.64,
    y: 140.02,
    width: 74.4,
    height: 0.43,
    transform: "translate(-28.22 238.04) rotate(-67.26)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 164.62,
    y: 103.04,
    width: 0.43,
    height: 74.4,
    transform: "translate(-40.83 72.85) rotate(-22.25)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 164.63,
    y: 103.04,
    width: 0.43,
    height: 74.4,
    transform: "translate(-28.24 238.02) rotate(-67.25)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 127.64,
    y: 140.02,
    width: 74.4,
    height: 0.43,
    transform: "translate(-40.85 72.93) rotate(-22.27)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 127.64,
    y: 140.02,
    width: 74.4,
    height: 0.43,
    transform: "translate(-3.8 275.88) rotate(-79.2)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 164.63,
    y: 103.04,
    width: 0.43,
    height: 74.4,
    transform: "translate(-50.3 116.74) rotate(-34.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 164.62,
    y: 103.04,
    width: 0.43,
    height: 74.4,
    transform: "translate(-3.91 275.75) rotate(-79.15)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 127.64,
    y: 140.02,
    width: 74.4,
    height: 0.43,
    transform: "translate(-50.29 116.63) rotate(-34.13)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 127.64,
    y: 140.02,
    width: 74.4,
    height: 0.43,
    transform: "translate(-43.17 200.01) rotate(-56.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 164.62,
    y: 103.04,
    width: 0.43,
    height: 74.4,
    transform: "translate(-24.47 35.36) rotate(-11.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 164.63,
    y: 103.04,
    width: 0.43,
    height: 74.4,
    transform: "translate(-43.19 199.94) rotate(-56.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 127.64,
    y: 140.02,
    width: 74.4,
    height: 0.43,
    transform: "translate(-24.39 35.21) rotate(-11.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M164.84,177.73a37.49,37.49,0,1,1,37.49-37.49A37.54,37.54,0,0,1,164.84,177.73Zm0-70.1a32.61,32.61,0,1,0,32.61,32.61A32.65,32.65,0,0,0,164.84,107.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M168.87,140.24a4,4,0,1,1-4-4A4,4,0,0,1,168.87,140.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M164.84,180a39.79,39.79,0,1,1,39.79-39.79A39.84,39.84,0,0,1,164.84,180Zm0-74.4a34.61,34.61,0,1,0,34.61,34.61A34.65,34.65,0,0,0,164.84,105.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M166,137.79l-36-46.2-2.74,2.64,35,44.94a2.64,2.64,0,0,0-.15.89,2.61,2.61,0,1,0,3.88-2.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M112.5,92.28l-.14.24c.47.43,1,.82,1.4,1.28,3.78,4.17,7.6,8.3,11.29,12.55a20.62,20.62,0,0,1,2.19,3.91c.37.7,0,0,.81,1a3.71,3.71,0,0,0,.72.56c1.28,1,1.72,2.62,3.27,3.91-.32.13.15-.13,0,0,1,1.47-.26-.1,1,1.47,2.66,3.27,6.49,5.11,9.41,8,1.87,1.84,3.13,4.34,4.49,6.64a2.2,2.2,0,0,1-.34,2.09,31.41,31.41,0,0,1-4.15,2.65c-1.67,1-4.08.64-5.06,2.84-4.08,1.27-6.5,4.87-9.92,7.07a9.53,9.53,0,0,1-6.59,1.47c-1.66-.22-2.2-1.21-1.5-2.76a10.4,10.4,0,0,1,1.84-2.18c.09-.09.25-.14.29-.24.87-2.27,1.71-4.55,2.59-6.82a3.64,3.64,0,0,1,.78-1.47c1.5-1.27,1.43-3.25,2.32-4.79,1-1.76-.07-3.42-.83-4.9a30.33,30.33,0,0,0-3.19-4.64,28.3,28.3,0,0,0-7.51-6.39,67.13,67.13,0,0,1-6.58-5c-1.56-1.28-3-2.72-4.78-4.36a15.68,15.68,0,0,0-.24,2c.09,4.19.4,8.39.26,12.57a34.09,34.09,0,0,0,.55,8.19,22.61,22.61,0,0,0,2.47,6.61,47.77,47.77,0,0,1,2.62,5.5c.79,2-.13,3.25-2.67,3.82s-5.31,1.13-8,1.68a7.17,7.17,0,0,1-.9.18A6.19,6.19,0,0,0,93,148.49c-1.38,2.7-3.93,3.17-6.7,1.71-1.46-.77-2.8-1.78-4.31-2.43-1.1-.47-2.43-.37-3.56-.81a26.28,26.28,0,0,1-4.17-2.18,1.45,1.45,0,0,1,0-1.33c1.41-.94,2.59-2.35,4.77-1.44.87.36,2.29-.48,3.42-.88.45-.15.77-.66,1.2-.91,1.32-.8,3-1.16,3.36-3.05a1.88,1.88,0,0,1,1.22-1.09c1.13-.24,1.5-1.29,2.26-1.83,3.2-2.28,2.44-5.8,3.14-8.87.19-.84.59-1.63.86-2.46a2.91,2.91,0,0,0,.26-1.3,73.17,73.17,0,0,0-1.93-9.82,139.61,139.61,0,0,1-4.43-18c-.31-1.7-1.51-3.22-2-4.91-1-3.34-2.34-6.66-2.23-10.23A4.45,4.45,0,0,1,86,75.14c1.51-1.15,2.62-2.82,4.1-4,2.81-2.29,5.74-4.45,8.65-6.62,3.11-2.31,6.19-4.66,9.41-6.8,2.11-1.41,4.46-2.45,6.66-3.72a6.57,6.57,0,0,0,1.25-1.32c-.69-.1-1.38-.26-2.07-.29-1,0-2,0-3.06,0a26.34,26.34,0,0,0-3.94-.26,4.06,4.06,0,0,1-3.66-1c-1.23-1.24-2.67-.44-3.91-.15-1.71.4-3,.52-4.5-.83-.89-.82-2.42-1-3.71-1.29-.32-.07-1.06.58-1.18,1a62,62,0,0,1-5.44,12.94c-1.14,2.1-1.86,4.43-2.8,6.64a3,3,0,0,1-.87,1.24c-2.94,2-5.21,5-8.6,6.34-1.83.75-3.68,1.43-5.51,2.17-1.52.61-3,1.3-4.54,1.89-2.24.87-4.58,1.53-6.74,2.56-2.93,1.4-5.77,3-8.59,4.65-3.26,1.89-5.7,1.47-8.27-1.36a36,36,0,0,0-4-3.49A1.63,1.63,0,0,1,34.37,81c1.92-2.9,5.61-5,9.38-3,2,1,6.53-.21,8.11-2,.17-.19.29-.48.49-.56,2.3-1,4.6-2,6.91-2.93a5.16,5.16,0,0,0,1.39-.62c3.09-2.59,6.26-5.1,9.18-7.87A12.2,12.2,0,0,0,74,55.22a10.13,10.13,0,0,1,1.91-5.12c1.27-1.83,1-3.69.92-5.59,0-1.42-.33-2.84-.45-4.27-.09-1.09-.69-1.45-1.7-1.57-1.49-.17-3-.49-4.46-.71a2.28,2.28,0,0,0-1,.07,3.87,3.87,0,0,1-2.59-.17,5.43,5.43,0,0,0-3.34.55c-2.69,1.12-5.08.08-5.92-2.75a3.78,3.78,0,0,0-3.12-1.75c-1.83.45-2.1.22-2.56-1.52a16.43,16.43,0,0,0-1.28-3.24c-.48-1-1.23-1.69-.9-3,.23-.93-1-1.47-2-.88s-1.37.35-1.6-.56c-1-4-2-8-.17-12A8.91,8.91,0,0,1,48.36,9.1C52,6.47,55.82,4,59.71,1.68,61.21.79,63.11.56,64.93,0l.33,1.54c3.09-.06,2.13,2.21,2.19,3.92l-5.18,5.87.34.31a8.65,8.65,0,0,0,5-5.15c.12-.28-.09-.69-.15-1l.28-.13,2-1.1c.1.68.15,1.38.31,2.05s.41,1.37.65,2.15l.93-.15a5.94,5.94,0,0,0,.12.65A27.17,27.17,0,0,0,73,12.31c1.24,2.47,2.14,8.23,2.28,11,.07,1.29,2.27-.85,2.75-.2s1.58-.72,2.45-1.08c2.36-1,4.73-1.93,7.12-2.83A5.14,5.14,0,0,1,89.26,19c4.75-.12,9.5-.29,14.26-.29,4.4,0,8.8.15,13.2.33a4.44,4.44,0,0,1,1.18.09s1.36.13,1.88.14c.36,0,1.53.05,1.94.5,3.39.14,5.45,1.56,8.47,3.38,1.26.76,2.8,1.13,3.88,2.06,3.3,2.88,6.52,5.88,9.61,9a83,83,0,0,1,6.42,7.22,16.29,16.29,0,0,1,3.74,12.44,20.11,20.11,0,0,1-.88,4.66,15,15,0,0,1-2.36,3.62,4.9,4.9,0,0,1-1.6,1.18c-4.31,2.43-7.91,5.79-11.65,9a30.45,30.45,0,0,1-2.74,1.84c-.11.07-.15.22-.23.32a9,9,0,0,1-1.7,2c-3.14,2-6.38,3.85-9.54,5.84-2.59,1.63-5.11,3.36-7.66,5-.88.58-4.46,2.29-4.1,3.62M53,13.75c1.34-1.48,2.67-3,4.28-4.76-2,1.22-3.68,2.28-4.58,4.16a2.72,2.72,0,0,0-1.37,3.75ZM106.21,142c2.22-.82,2.85-2,1.8-3.53a36.73,36.73,0,0,0-3.43-3.75L104,135a3.5,3.5,0,0,0,.44,1.12c.65.76,1.42,1.41,2.08,2.16a20.87,20.87,0,0,1,1.24,1.83Zm-22.87,3.59c.46,1.62,6.83,1.24,9.27-.38C89.58,145.56,86.6,146.78,83.34,145.54ZM56.83,13.28l.49.33,4-6.52-.57-.35ZM93.56,143.4l.09-.8-6.71-.37v.19ZM57.47,6.41l.46.7c.53-.35,1-.68,1.55-1.06,0,0-.29-.44-.44-.68Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "115.73 150.66 115.62 149.8 164.57 143.27 164.68 144.13 115.73 150.66"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 138.96,
    y: 108.09,
    width: 1.29,
    height: 49.89,
    transform: "translate(-16.02 246.92) rotate(-79.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M114.86,139.27a2.21,2.21,0,1,1-2.2-2.21A2.19,2.19,0,0,1,114.86,139.27Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 164.62,
    y: 102.9,
    width: 0.43,
    height: 74.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 164.63,
    y: 102.9,
    width: 0.43,
    height: 74.4,
    transform: "translate(-50.78 157.59) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 127.64,
    y: 139.88,
    width: 74.4,
    height: 0.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 127.64,
    y: 139.88,
    width: 74.4,
    height: 0.43,
    transform: "translate(-50.78 157.59) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 127.64,
    y: 139.88,
    width: 74.4,
    height: 0.43,
    transform: "translate(-28.09 237.96) rotate(-67.26)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 164.62,
    y: 102.9,
    width: 0.43,
    height: 74.4,
    transform: "translate(-40.77 72.84) rotate(-22.25)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 164.63,
    y: 102.9,
    width: 0.43,
    height: 74.4,
    transform: "translate(-28.11 237.93) rotate(-67.25)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 127.64,
    y: 139.88,
    width: 74.4,
    height: 0.43,
    transform: "translate(-40.8 72.92) rotate(-22.27)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 127.64,
    y: 139.88,
    width: 74.4,
    height: 0.43,
    transform: "translate(-3.67 275.77) rotate(-79.2)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 164.63,
    y: 102.9,
    width: 0.43,
    height: 74.4,
    transform: "translate(-50.23 116.71) rotate(-34.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 164.62,
    y: 102.9,
    width: 0.43,
    height: 74.4,
    transform: "translate(-3.77 275.64) rotate(-79.15)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 127.64,
    y: 139.88,
    width: 74.4,
    height: 0.43,
    transform: "translate(-50.21 116.6) rotate(-34.13)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 127.64,
    y: 139.88,
    width: 74.4,
    height: 0.43,
    transform: "translate(-43.05 199.95) rotate(-56.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 164.62,
    y: 102.9,
    width: 0.43,
    height: 74.4,
    transform: "translate(-24.44 35.36) rotate(-11.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 164.63,
    y: 102.9,
    width: 0.43,
    height: 74.4,
    transform: "translate(-43.07 199.88) rotate(-56.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 127.64,
    y: 139.88,
    width: 74.4,
    height: 0.43,
    transform: "translate(-24.36 35.21) rotate(-11.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M164.84,177.59a37.49,37.49,0,1,1,37.49-37.49A37.54,37.54,0,0,1,164.84,177.59Zm0-70.1a32.61,32.61,0,1,0,32.61,32.61A32.65,32.65,0,0,0,164.84,107.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M168.87,140.1a4,4,0,1,1-4-4A4,4,0,0,1,168.87,140.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M164.84,179.89a39.79,39.79,0,1,1,39.79-39.79A39.84,39.84,0,0,1,164.84,179.89Zm0-74.4a34.61,34.61,0,1,0,34.61,34.61A34.65,34.65,0,0,0,164.84,105.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M166,137.65l-36-46.2-2.74,2.64,35,44.94a2.64,2.64,0,0,0-.15.89,2.61,2.61,0,1,0,3.88-2.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "117.5 119.3 121.37 119.6 133.94 79.35 129.95 78.81 117.5 119.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "124.8 93.81 103.58 93.81 101.9 90 124.8 90 124.8 93.81"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositionAero);
export default __webpack_public_path__ + "static/media/position-aero.745ba5833a690abb4b31c4e86a7b9c88.svg";
export { ForwardRef as ReactComponent };